import { log_error, log_info } from "./log";
import {
  IS_LOGGED,
  PHNO,
  THEME_COLOR,
  USER_ID,
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  PROFILE_LOGIN,
  GOOGLE_USER,
  LOGIN_BY,
  USER_EMAIL,
} from "./store-data-constants";

// Save data
export const saveData = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    log_info(`Saved ${key}`);
  } catch (error) {
    log_error("Error saving data:", error);
  }
};

// Retrieve data
export const getData = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      return JSON.parse(value);
    }
  } catch (error) {
    log_error("Error retrieving data:", error);
  }
  return null;
};

// Clear specific keys
export const clearAllData = () => {
  try {
    localStorage.removeItem(IS_LOGGED);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(THEME_COLOR);
    localStorage.removeItem(PHNO);
    localStorage.removeItem(AGENT_LOGIN);
    localStorage.removeItem(CLIENT_LOGIN);
    localStorage.removeItem(CLIENT_PROFILE_CODE);
    localStorage.removeItem(PROFILE_LOGIN);
    localStorage.removeItem(GOOGLE_USER);
    localStorage.removeItem(LOGIN_BY);
    localStorage.removeItem(USER_EMAIL);
    log_info("Cleared selected data from localStorage");
  } catch (error) {
    log_error("Error clearing data:", error);
  }
};





export const clearLoginData = async () => {
  try {
    await localStorage.removeItem(GOOGLE_USER);
    await localStorage.removeItem(PHNO);
    await localStorage.removeItem(LOGIN_BY);
    await localStorage.removeItem(USER_EMAIL);
  } catch (error) {
    console.error("Error retrieving data:", error);
  }
};
